import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2502db88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = {
  key: 0,
  class: "edit_switch"
}
const _hoisted_3 = { class: "tags" }

import DialogBase from '@/components/molecules/DialogBase'
import TagList from './components/TagList'
import TagEditList from './components/TagEditList'
import SimpleSwitch from '@/components/atoms/SimpleSwitch'
import API from '@/js/const/api'
import http from '@/js/utils/http'
import { Camera, CameratagWithCameras } from '@/@types/typescript-axios'
import { computed, ref, watch, withDefaults } from 'vue'
import { useStore } from 'vuex'
import axios from 'axios'
type PropsType = {
  toggleState?: boolean
  checkedCameras: Camera[]
}

type tagsStatusType = {
  [key: string]: { checked: boolean; indeterminate: boolean }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  props: {
    toggleState: { type: Boolean, default: false },
    checkedCameras: null
  },
  emits: ["updateCameraList", "update:toggleState"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updateCameraList'): void
  (e: 'update:toggleState', toggleState: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { toggleState: boolean, checkedCameras: Camera[] };

const store = useStore()



const isEdit = ref<boolean>(false)
const tagsStatus = ref<tagsStatusType>({})
const loading = ref<boolean>(false)
const updateCameraListState = ref<boolean>(false)



const tags = computed(() => store.getters['tag/tags'])

const displayFlag = computed({
  get: () => props.toggleState,
  set: (v) => {
    emit('update:toggleState', v)
  },
})

const cameraName = computed<string>(() => {
  let name = ''
  // カメラ設定が1台の場合はカメラ名を表示する
  if (props.checkedCameras.length === 1) {
    name = `${props.checkedCameras[0].camera_name}`
  }
  return name
})

const editSwitchShow = computed<boolean>(() => props.checkedCameras.length > 0)

const setTagsStatus = () => {
  const status: tagsStatusType = {}
  if (props.checkedCameras.length > 0) {
    tags.value.forEach((d: CameratagWithCameras) => {
      status[d.tag_code] = getCheckboxStatus(d.tag_code, props.checkedCameras)
    })
  }
  tagsStatus.value = status
}

/**
 * タグの選択状態取得用
 * @param {String} tagCode タグコード
 * @param {Array} cameras 選択中のカメラ一覧
 */
const getCheckboxStatus = (tagCode: string, cameras: Camera[]) => {
  const cameraLength = cameras.length
  const status = {
    checked: false,
    indeterminate: false,
  }

  const t = cameras.filter((d) => {
    if (!d.tags) {
      return []
    }
    const hasTag = d.tags.find((t) => {
      return tagCode === t.tag_code
    })

    return hasTag
  })

  // タグが選択中のカメラ全ての紐付いている場合
  if (cameraLength === t.length && t.length !== 0) {
    status.checked = true
  }
  // タグが選択中のカメラの一部に紐付いている場合
  else if (cameraLength > t.length && t.length !== 0) {
    status.checked = true
    status.indeterminate = true
  }

  return status
}

/**
 * タグ設定
 */
const setTags = async () => {
  // ボタンにプリローダーを表示
  loading.value = true
  const params = getRequestParams()
  try {
    await http.post(API.CAMERA_TAG_ASSIGN, params)

    // TODO タグの設定情報が更新された場合にカメラリストを再取得しているが、変更があったカメラだけ更新するようにしたい
    emit('updateCameraList')
    displayFlag.value = false

    // カメラの紐づけ情報が変更されたので、タグ一覧を取得し直す
    await store.dispatch('tag/getTags')
  } catch (error: unknown) {
    // 500系は http の共通エラー表示済み。失敗時はダイアログを閉じずローディングのみ解除する
    if (!axios.isAxiosError(error)) throw error
  } finally {
    loading.value = false
  }
}

/**
 * タグ設定用のリクエストパラメーターを作成
 * @return {Object} リクエストパラメーター
 */
const getRequestParams = (): object => {
  // タグの選択状態のtag_code
  const tagCodes = Object.keys(tagsStatus.value)

  // 選択中のカメラのカメラコード
  const cameraCode = props.checkedCameras.map((d) => d.camera_code)
  // セットするカメラコード( indeterminateがtrueのものは変更対象にいれない)
  const setTagCode = tagCodes.filter(
    (d) => tagsStatus.value[d].checked && !tagsStatus.value[d].indeterminate
  )
  // 解除するカメラコード
  const unsetTagCode = tagCodes.filter((d) => !tagsStatus.value[d].checked)

  return {
    camera_code: cameraCode,
    set_tag_code: setTagCode,
    unset_tag_code: unsetTagCode,
  }
}

const updateCameraList = () => {
  updateCameraListState.value = true
}

watch(displayFlag, (v) => {
  if (v) {
    // モーダル表示のタイミングでタグのデフォルト値を設定する
    setTagsStatus()
    updateCameraListState.value = false
    if (props.checkedCameras.length === 0) {
      // タグを選択しなかった場合編集状態をオンにする
      isEdit.value = true
    } else {
      // 編集状態をオフにする
      isEdit.value = false
    }
  } else {
    if (updateCameraListState.value) {
      emit('updateCameraList')
    }
  }
})

watch(tags, () => {
  // タグ情報が変更されたら、タグのステータス情報を更新する
  setTagsStatus()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogBase), {
    modelValue: _unref(displayFlag),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(displayFlag) ? (displayFlag).value = $event : null)),
    useFooter: !isEdit.value,
    loading: loading.value,
    onApprove: setTags
  }, {
    title: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t('tag_dialog_main.tag_settings')), 1),
        _createElementVNode("span", null, _toDisplayString(_unref(cameraName)), 1)
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        (_unref(editSwitchShow))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('tag_dialog_main.edit')), 1),
              _createElementVNode("span", null, [
                _createVNode(_unref(SimpleSwitch), {
                  modelValue: isEdit.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isEdit).value = $event))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (!isEdit.value)
            ? (_openBlock(), _createBlock(_unref(TagList), {
                key: 0,
                tags: _unref(tags),
                "tags-status": tagsStatus.value,
                "onUpdate:tags-status": _cache[1] || (_cache[1] = ($event: any) => ((tagsStatus).value = $event))
              }, null, 8, ["tags", "tags-status"]))
            : _createCommentVNode("", true),
          (isEdit.value)
            ? (_openBlock(), _createBlock(_unref(TagEditList), {
                key: 1,
                tags: _unref(tags),
                onUpdateCameraList: updateCameraList
              }, null, 8, ["tags"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "useFooter", "loading"]))
}
}

})